import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h4 mb-4"
}
const _hoisted_2 = { class: "text-h5 text-blue-grey-darken-4 font-weight-bold" }
const _hoisted_3 = { "data-label": "Name" }
const _hoisted_4 = { "data-label": "Case" }
const _hoisted_5 = { "data-label": "Issuing Agency" }
const _hoisted_6 = {
  "data-label": "Balance Due",
  class: "text-right"
}
const _hoisted_7 = { "data-label": "Amount To Pay" }
const _hoisted_8 = { "data-label": "" }
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}

import { computed } from 'vue';
import { Rules } from '@/rules';
import { useRouter } from 'vue-router';
import { injectStrict, CurrencyJSKey } from '@/symbols';
import { useCartStore } from '@/stores/cart';
import { useUserStore } from '@/stores/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShoppingCart',
  setup(__props) {

/*global Server*/
const Currency = injectStrict(CurrencyJSKey);
const router = useRouter();
const cartStore = useCartStore();
const userStore = useUserStore();

const citationsTotal = computed(() => {
  return cartStore.citations.reduce((total, item) => {
    return total + item.Overview.AmountToPay;
  }, 0);
});

// Computed: Total calculation
const orderTotal = computed(() => {
  return citationsTotal.value;
});

const isCheckoutBtnDisabled = computed(() => {
  return (cartStore.citations.length === 0) || orderTotal.value <= 0;
});

const removeCitation = (item: Server.ICitationSearchResult) => {
  cartStore.removeCitation(item);
};

function formatCurrency(amount?: number | string | undefined): string {
  if (amount != null && amount != '' && amount != undefined) {
    return Currency(amount).format();
  }
  return '$0.00';
}


const amountIsGreaterThanMinRule = (value: number, balance: number, minAmountToPay: number): string | boolean => {

  const min = balance < minAmountToPay ? balance : minAmountToPay;

  if (value == null || value == undefined || value == 0) {
    return "Payment must be at least " + formatCurrency(minAmountToPay);
  }

  return value >= min || "Payment must be at least " + formatCurrency(min);
};

const amountIsLessThanBalanceRule = (value: number, balance: number): string | boolean => {
  return value <= balance || "Payment must be equal or less than " + formatCurrency(balance);
};

function displayCourtName(item: Server.ICitationSearchResult): string {
  if (item.Overview.Court == 'F') {
    return '1st Parish Court';
  } else if (item.Overview.Court == 'S') {
    return '2nd Parish Court';
  }
  return '';
}

function minAmountToPay(item: Server.ICitationSearchResult): number {
  return (item.Overview.PartialPaymentInstallmentDate == null || item.Overview.PartialPaymentInstallmentDate == "" || item.Overview.PartialPaymentInstallmentVerbiage == null || item.Overview.PartialPaymentInstallmentVerbiage == "") ? (item.Overview.FullPaymentAmountDue || 0) : (item.Overview.PartialFeeFineContemptPaymentAmountDue || 0) + (item.Overview.PartialProbationPaymentAmountDue || 0);
}

function checkout() {
  if (userStore.user != null && Object.keys(userStore.user).length > 0) {
    router.push({ name: 'checkout' })
  } else {
    router.push({ name: 'paymentLoginCheck' })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-6" }, {
    default: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-h2 font-weight-bold mb-8 pt-8 text-blue-grey-darken-4" }, "Shopping Cart", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-body-1 pb-6" }, "Review your order details below", -1)),
      (_unref(cartStore).citations.length > 0)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_1, "Cases:"))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            lg: "9"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).citations, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.Overview.Court + item.Overview.CaseNo
                }, [
                  _createVNode(_component_v_card, {
                    class: "pa-4 pa-sm-6 mb-4",
                    color: "white",
                    elevation: "4",
                    rounded: "lg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { align: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "5"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h4", _hoisted_2, _toDisplayString(item.Overview.Court + item.Overview.CaseNo), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, {
                        align: "center",
                        class: "mt-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_table, { class: "responsive-table" }, {
                                default: _withCtx(() => [
                                  _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "Name"),
                                      _createElementVNode("th", null, "Case"),
                                      _createElementVNode("th", null, "Issuing Agency"),
                                      _createElementVNode("th", { class: "text-right" }, "Balance Due"),
                                      _createElementVNode("th", null, "Amount To Pay"),
                                      _createElementVNode("td")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_3, _toDisplayString((item.Overview.LastNameFromSearch || '') + " " +
                        (item.Overview.FirstNameFromSearch || '') + " " + (item.Overview.MI || '')), 1),
                                      _createElementVNode("td", _hoisted_4, _toDisplayString(item.Overview.CaseNo), 1),
                                      _createElementVNode("td", _hoisted_5, _toDisplayString(displayCourtName(item)), 1),
                                      _createElementVNode("td", _hoisted_6, _toDisplayString(formatCurrency(item.Overview.FullPaymentAmountDue)), 1),
                                      _createElementVNode("td", _hoisted_7, [
                                        _createVNode(_component_v_number_input, {
                                          modelValue: item.Overview.AmountToPay,
                                          "onUpdate:modelValue": ($event: any) => ((item.Overview.AmountToPay) = $event),
                                          "control-variant": "hidden",
                                          variant: "outlined",
                                          density: "compact",
                                          class: "mt-5",
                                          precision: 2,
                                          min: (item.Overview.FullPaymentAmountDue || 0) < minAmountToPay(item) ? (item.Overview.FullPaymentAmountDue || 0) : minAmountToPay(item),
                                          max: (item.Overview.FullPaymentAmountDue || 0),
                                          prefix: "$",
                                          rules: [_unref(Rules).required, (value) => amountIsGreaterThanMinRule(value, (item.Overview.FullPaymentAmountDue || 0), minAmountToPay(item)), (value) => amountIsLessThanBalanceRule(value, (item.Overview.FullPaymentAmountDue || 0))],
                                          label: "Amount to Pay"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "rules"])
                                      ]),
                                      _createElementVNode("td", _hoisted_8, [
                                        _createVNode(_component_v_btn, {
                                          variant: "text",
                                          color: "blue-darken-2",
                                          class: "font-weight-medium",
                                          onClick: ($event: any) => (removeCitation(item))
                                        }, {
                                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createTextVNode(" Remove ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  (index < _unref(cartStore).citations.length - 1)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 0,
                        class: "my-4",
                        color: "grey-darken-2"
                      }))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            lg: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-5 summary-card",
                color: "white",
                elevation: "4",
                rounded: "lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5 font-weight-semibold pa-0 mb-4" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Order Summary", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider, {
                    class: "mb-4",
                    color: "grey-darken-2"
                  }),
                  (_unref(cartStore).citations.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_v_row, {
                          dense: "",
                          class: "mb-2 text-subtitle-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("Cases", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "text-right font-weight-medium" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatCurrency(citationsTotal.value)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider, {
                    class: "mb-4",
                    color: "grey-darken-2"
                  }),
                  _createVNode(_component_v_row, {
                    dense: "",
                    class: "font-weight-bold mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "text-h6" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("Order Total", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { class: "text-right text-h6" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formatCurrency(orderTotal.value)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    onClick: checkout,
                    height: "44",
                    color: "blue-darken-2",
                    size: "large",
                    disabled: isCheckoutBtnDisabled.value,
                    class: "text-capitalize font-weight-bold"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" CHECKOUT ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})